import {useEffect} from 'react';
import axios from "axios";
import {message} from "antd";
import {useHistory} from "react-router-dom";

const BAD_REQUEST_MESSAGES = {
    UPLOAD_URL_EXPIRE_TIME_OUT_OF_RANGE: 'Upload expire time must be between 1 hour and 30 days (720 hours).',
};

const FORBIDDEN_MESSAGES = {
    MISMATCH_ID_PW: 'Please check ID or Password.',
    CANNOT_ACCESS_ROLE: 'You do not have permission to access this menu.',
    CANNOT_ACCESS_ENTITY: 'You do not have permission to access this item.',
};

const AxiosInterceptor = ({children}) => {
    const history = useHistory();

    axios.defaults.baseURL = process.env.REACT_APP_API_URL === undefined ? 'https://upload.imagetrial.com' : process.env.REACT_APP_API_URL;
    axios.defaults.headers['X-AUTH-TOKEN'] = window.localStorage.getItem('token');

    useEffect(() => {
        const resInterceptor = response => {
            return response;
        }

        const errInterceptor = error => {
            if (!error.response) {
                message.error({content: 'Please check your network connection.'}).then();
                return Promise.reject(error);
            }
            if (error.response.status === 400) {
                const {code, message: serverMessage} = error.response.data ?? {};
                message.error({content: BAD_REQUEST_MESSAGES[code] ?? serverMessage ?? 'Please check your input.'}).then();
            }
            if (error.response.status === 401) {
                window.localStorage.clear();
                if (window.location.pathname !== '/') {
                    message.error({content: 'Your session has expired. Please log in again.'}).then();
                    window.location.href = window.location.origin;
                }
            }
            if (error.response.status === 403) {
                const {code} = error.response.data ?? {};
                message.error({content: FORBIDDEN_MESSAGES[code] ?? 'Please check ID or Password.'}).then();
                if (code === 'CANNOT_ACCESS_ROLE') {
                    history.replace('/main');
                }
            }
            if (error.response.status === 409) {
                message.error({content: 'You are already a registered user.'}).then();
            }
            if (error.response.status === 500) {
                message.error({content: 'Please contact the administrator.'}).then();
            }
            return Promise.reject(error);
        }

        const interceptor = axios.interceptors.response.use(resInterceptor, errInterceptor);

        return () => axios.interceptors.response.eject(interceptor);

    }, [history]);
    return children;
};

export {AxiosInterceptor};